<script>
  import Bleed from "$lib/components/Bleed.svelte";
  import { onMount } from "svelte";
  export let data;

  let clazz = "";
  export { clazz as class };

  export let fullWidth = false;

  let fbClass = data.fields.url.indexOf("watch") > 0 ? "fb-video" : "fb-post";

  onMount(() => {
    window.FB && window.FB.XFBML.parse();
  });
</script>

<svelte:head>
  <script
    id="facebook-of"
    async={true}
    defer={false}
    crossorigin="anonymous"
    src="https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v15.0"
    nonce="D1ZbbVhD"
  ></script>
</svelte:head>

<div id="fb-root" />

<Bleed {fullWidth} class={clazz}>
  <div
    class="facebook-of max-sm:w-screen w-[345px] md:w-360 mx-auto bg-white"
    data-chromatic="ignore"
  >
    <div
      class="mx-auto {fbClass}"
      data-href={data.fields.url}
      data-width="auto"
      data-show-text="true"
      data-lazy="true"
    />
  </div>
</Bleed>
